import { Icon, IconColor, IconID } from '@hub/common/Icon/Icon';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';

type AboutChemicalPropertiesProps = {
  setShowAboutChemicalProperties: (value: boolean) => void;
};

type ChemicalPropertiesInformation = {
  title: string;
  description: string;
};

export const AboutChemicalProperties = ({ setShowAboutChemicalProperties }: AboutChemicalPropertiesProps) => {
  const { t } = useTranslation(['category/productFilter', 'common']);

  const chemicalPropertiesInformations: ChemicalPropertiesInformation[] = [
    {
      title: t(`ABOUT-CHEMICAL-PROPERTIES.INFO_TITLE`, { ns: 'free-form-hub/materials' }),
      description: t('ABOUT-CHEMICAL-PROPERTIES.INFO_CONTENT', { ns: 'free-form-hub/materials' }),
    },
    {
      title: t(`ABOUT-CHEMICAL-PROPERTIES.RESISTANT_TITLE`, { ns: 'free-form-hub/materials' }),
      description: t('ABOUT-CHEMICAL-PROPERTIES.RESISTANT_TEXT', { ns: 'free-form-hub/materials' }),
    },
    {
      title: t(`ABOUT-CHEMICAL-PROPERTIES.PARTLY_RESISTANT_TITLE`, { ns: 'free-form-hub/materials' }),
      description: t('ABOUT-CHEMICAL-PROPERTIES.PARTLY_RESISTANT_TEXT', { ns: 'free-form-hub/materials' }),
    },
  ];

  const about = (info: ChemicalPropertiesInformation) => (
    <div className="px-60 mt-8">
      <span className="text-[20px]">{info.title}</span>
      <div
        className="text-sm mt-4"
        dangerouslySetInnerHTML={{
          __html: info.description,
        }}
      />
    </div>
  );
  return (
    <div className="w-[calc(100vw-16px)] h-[100vh] overflow-auto">
      <div>
        <div className="flex justify-between px-60 pt-24">
          <div>
            <span className="text-4xl font-semibold">
              {t('ABOUT-CHEMICAL-PROPERTIES.TITLE', { ns: 'free-form-hub/materials' })}
            </span>
          </div>
          <button
            onClick={() => {
              setShowAboutChemicalProperties(false);
            }}
            type="button"
            data-testid="dialog-close-icon"
            className={classNames('w-16 h-16')}
          >
            <Icon size={10} color={IconColor.BLACK} id={IconID.CLOSE_CROSS} />
          </button>
        </div>
      </div>
      {chemicalPropertiesInformations.map(info => about(info))}
    </div>
  );
};
